/* eslint-disable react-native/no-inline-styles */
import React, { FC } from 'react';
import { Text, TouchableOpacity, StyleSheet, ActivityIndicator, GestureResponderEvent } from 'react-native';

import ColorsWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { moderateScale } from '@helpers';
import { WithColorProps } from '@styles/colors/types';

interface ButtonProps extends WithColorProps {
  name: string;
  onPress: (e: GestureResponderEvent) => void;
  disabled?: boolean;
  big?: boolean;
  bg: string;
  width: number;
  maxWidth?: number;
  height: number;
  loading?: boolean;
  borderRadius: number;
}

const Button: FC<ButtonProps> = ({ name, onPress, disabled = false, big, bg, width, maxWidth, height, loading = false, C, borderRadius }) => {
  return (
    <TouchableOpacity
      activeOpacity={disabled ? 1 : 0.6}
      onPress={disabled || loading ? () => {} : onPress}
      style={[
        styles.mainContainer,
        {
          backgroundColor: C(disabled ? 'Button/Light/Disabled' : 'Other / Light / Logo / Smart'),
        },
        big ? { height: 58.5 } : {},
        bg ? { backgroundColor: bg } : {},
        width ? { width: width } : {},
        maxWidth ? { maxWidth: maxWidth } : {},
        height ? { height: height } : {},
        borderRadius ? { borderRadius: borderRadius } : {},
      ]}
    >
      {loading ? (
        <ActivityIndicator size="large" color={C('Label/Light/Inverted')} />
      ) : (
        <Text style={[font.Headline, { color: C(disabled ? 'Label/Light/Quinary' : 'Label/Light/Inverted') }]}>{name}</Text>
      )}
    </TouchableOpacity>
  );
};

export default ColorsWrapper(Button);

const styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: '#E51D73',
    borderRadius: moderateScale(6),
    width: '100%',
    height: moderateScale(54),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
